import { render } from "./ReturnToPortalButton.vue?vue&type=template&id=5d995a0b&scoped=true"
import script from "./ReturnToPortalButton.vue?vue&type=script&lang=js"
export * from "./ReturnToPortalButton.vue?vue&type=script&lang=js"

import "./ReturnToPortalButton.vue?vue&type=style&index=0&id=5d995a0b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d995a0b"]])

export default __exports__